import { SearchType } from "../types/searchType";
import useJourneySearchFormContext from "./useJourneySearchFormContext";
const useIsOpenReturn = () => {
  const { watch } = useJourneySearchFormContext();
  const searchType = watch("searchType");
  return searchType === SearchType.OpenReturn;
};
var useIsOpenReturn_default = useIsOpenReturn;
export {
  useIsOpenReturn_default as default
};
